var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"discover-infinite"},[_c('div',{ref:"hit",staticClass:"discover-infinite-hit"}),(_vm.loading)?_c('div',{staticClass:"discover-infinite-tip"},[_vm._v("加载中…")]):(_vm.done)?_c('div',{staticClass:"discover-infinite-tip"},[_vm._v("没有更多了")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }